import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchDTFieldsFailure,
  fetchDTFieldsStart,
  fetchDTFieldsSuccess,
} from "../../store/features/digitalTwin/dTFieldsSlice";

const URL = "/fields/";

const getDTFields = async () => {
  try {
    const response = await fieldDataClient.get(URL);
    return response.data;
  } catch (error) {
    console.log("here error", error);
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchDTFieldsSaga() {
  try {
    const fieldsData = yield call(getDTFields);
    yield put(fetchDTFieldsSuccess(fieldsData));
  } catch (error) {
    yield put(fetchDTFieldsFailure(error.message));
  }
}

export default function* dTFieldsSaga() {
  yield takeLatest(fetchDTFieldsStart.type, fetchDTFieldsSaga);
}
